export default __webpack_public_path__ + "static/media/startTimer.45b08ed7.mp3";